<template>
  <v-card class="card" color="primary">
    <v-card-title>
      <div class="text-h5 font-weight-bold">Documentos</div>
      <v-spacer></v-spacer>
      <v-tabs v-model="selectedTab" color="secondary" fixed-tabs>
        <v-tab key="1" class="font-weight-bold">Vigentes</v-tab>
        <v-tab key="2" class="font-weight-bold">Archivados</v-tab>
      </v-tabs>
    </v-card-title>
    <v-card-text>
      <v-tabs-items v-model="selectedTab" class="transparent">
        <!-- TAB VIGENTES -->
        <v-tab-item key="1">
          <v-container>
            <v-row v-if="documentosVigentes && documentosVigentes.length > 0">
              <v-col cols="4" v-for="documento in documentosVigentes" :key="documento.id">
                <DocumentoCard
                  class="documento-card"
                  :documento="documento"
                  :openConfirmArchive="openConfirmArchive"
                  :openEditModal="openEditModal"
                  :archivado="false"
                />
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" align="center">
                <v-icon color="grey" size="256">mdi-folder-alert</v-icon>
                <div class="text-h6">Este elemento no ha registrado documentos vigentes</div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" align="center">
                <v-btn
                  v-if="perfil !== PERFILES['Administrador IPH+'] && perfil !== PERFILES['Policia']"
                  color="secondary"
                  :to="{ name: getRouteName, params: { id: id } }"
                >
                  Agregar documento
                </v-btn>
                <agrega-documento-dialog-component :id="id" v-else></agrega-documento-dialog-component>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <!-- TAB ARCHIVADOS -->
        <v-tab-item key="2">
          <v-container>
            <v-row v-if="documentosArchivados && documentosArchivados.length > 0">
              <v-col cols="4" v-for="documento in documentosArchivados" :key="documento.id">
                <DocumentoCard class="documento-card" :documento="documento" :archivado="true" />
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" align="center">
                <v-icon color="grey" size="256">mdi-folder-alert</v-icon>
                <div class="text-h6">No hay documentos archivados</div>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import AgregaDocumentoDialogComponent from '../../views/policia/AgregaDocumentoDialogComponent.vue'
import { DIALOG_TYPES } from '../../plugins/dialog-types'
import DocumentoCard from '../DocumentoCard.vue'
import { PERFILES } from '@/perfiles.js'

export default {
  components: {
    AgregaDocumentoDialogComponent,
    DocumentoCard,
  },
  props: {
    documentos: {
      type: Array,
    },
    id: {
      type: Number,
    },
    personal: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      selectedTab: 0,
      PERFILES,
      documentoAArchivar: null,
      DIALOG_TYPES,
    }
  },
  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
      documentosVigentes: 'documento/documentosVigentes',
      documentosArchivados: 'documento/documentosArchivados',
    }),
    getRouteName() {
      if (this.$route.matched.some(({ path }) => path === '/profesionalizacion')) {
        return 'agregaDocumentoPersonal'
      } else if (this.$route.matched.some(({ path }) => path === '/enlace_c3')) {
        return 'agregaDocumentoEnlace'
      } else if (this.$route.matched.some(({ path }) => path === '/personal')) {
        return 'agregaDocumentoRegistroPersonal'
      } else if (this.$route.matched.some(({ path }) => path === '/recursos_humanos')) {
        return 'recursos_humanos.agrega_documento_personal'
      } else {
        return 'policia.agrega_documento_personal'
      }
    },
  },
  async mounted() {
    await this.fetchTipoDocumento()
  },
  methods: {
    ...mapMutations('documento', ['SET_SELECTED_DOCUMENTO']),
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapActions('tipoDocumento', ['fetchTipoDocumento']),
    ...mapActions('documento', ['updateEstatusDocumentoPersonal', 'fetchDocumentoByPersonal']),
    openConfirmArchive(documento) {
      this.documentoAArchivar = documento
      this.SET_DIALOG({
        ...DIALOG_TYPES.CONFIRMACION_ARCHIVAR_DOCUMENTO,
        props: {
          onConfirm: this.confirmArchive,
        },
      })
    },
    async confirmArchive() {
      if (!this.documentoAArchivar) return
      await this.archiveDocument(this.documentoAArchivar)
      this.documentoAArchivar = null
      this.$store.dispatch('dialog/closeDialog')
    },
    openEditModal(documento) {
      this.SET_SELECTED_DOCUMENTO(documento)
      this.SET_DIALOG(DIALOG_TYPES.EDITAR_DOCUMENTO_REGISTRADO)
    },
    async archiveDocument(documento) {
      await this.updateEstatusDocumentoPersonal({
        fk_idPersonal: this.id,
        iddocumentosPersonal: documento.iddocumentosPersonal,
        fk_idEstatus: 4,
      })
      this.fetchDocumentoByPersonal(this.id)
      this.SET_SNACKBAR_MESSAGE('El documento fue archivado correctamente.')
    },
  },
}
</script>
